// extracted by mini-css-extract-plugin
export default {"container_edit_card_bi":"fYKW7j8hxIAPTdvwm51r","card_edit_bi_img_title":"epZvVxBVfYwmiG7yfszA","card_edit_bi_icons":"v8Oscn1VikQRg7kZOCE9"};